// extracted by mini-css-extract-plugin
module.exports = {"c1wvcfl4":"c1wvcfl4","wdnzpnc":"wdnzpnc"};